export const InputOTP = ({ cols, formInput }) => {
    return (
        <div className={`grid gap-4`} style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
            {formInput}
        </div>
    )
}
